
var preact = require('preact');
var hooks = require('preact/hooks');
module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","version":"1.0","width":"357.333","height":"330.667","viewBox":"0 0 268 248"},"content":"<path d=\"M83.2 30.6C63.1 36 45.6 48.6 39.8 62c-5.4 12.4-4.2 22.7 4.7 40.7 15.4 31 45.7 68.1 74 90.7 24.2 19.3 54.3 36.9 67.9 39.6 22.2 4.5 43.2-12.8 52.5-43.4 3.7-12 2.6-19.5-3.8-24.9-1.7-1.4-11.9-6.9-22.8-12.2-26.7-13.2-27.7-13.2-43-3.5l-5.3 3.3-5.6-3.7c-6.6-4.4-27.7-24.6-33.2-31.9-8-10.5-7.8-9.2-2.2-18.7 7.5-12.7 7.4-13.5-5.1-39.5-5.5-11.6-11.2-22.3-12.7-23.9-5.3-5.6-11.8-6.8-22-4zm17.3 35c4.7 9.7 8.5 18 8.5 18.5s-1.5 3.2-3.3 6.1c-1.8 2.9-3.8 6.6-4.5 8.1-1.8 4.1-1.4 12.6.7 17.2 6.4 13.9 37.3 44.9 52.5 52.7 7.5 3.8 18.6 1.9 27.3-4.8 4.1-3.1 3.2-3.3 25.6 7.7l14.9 7.3-.6 3.5c-.9 5.7-8.1 19.6-12.7 24.6-9.6 10.4-15.8 10.8-33.1 2.2-28-14-59.9-39.5-80.6-64.6-25.7-31-41.6-59.3-39.5-70.4 1.7-9.2 11.8-17.9 27.1-23.3 3.7-1.3 7.3-2.4 8-2.4.6 0 5 7.9 9.7 17.6z\" fill=\"currentColor\"/>"}
var attributes = module.exports.attributes;
var content = module.exports.content;

module.exports = function (props) {
	var ref = hooks.useRef();

	hooks.useEffect(function () {
		var div = document.createElement('div');
		div.innerHTML = '<svg>' + content + '</svg>';

		var source = div.firstChild;
		var dest = ref.current;

		while (source.firstChild) {
			dest && dest.appendChild(source.firstChild);
		}
	}, []);

	return preact.h('svg', Object.assign({ ref: ref }, attributes, props));
};
